<script lang="ts">
  import { useForm, usePage } from '@inertiajs/svelte';
  import { Button } from '$lib/components/ui/button';
  import { Card, CardContent, CardHeader, CardTitle } from '$lib/components/ui/card';
  import { Input } from '$lib/components/ui/input';
  import { Label } from '$lib/components/ui/label';

  // 💡 接收后端传过来的 token prop
  let { token }: { token: string } = $props();

  const form = useForm({
    password: '',
    password_confirmation: ''
  });

  const page = usePage();
  let flash = $derived((page.props as any).flash || {});
  let translations = $derived((page.props as any).translations || {});
  let t = $derived(translations.passwords || {});

  function submit(e: Event) {
    e.preventDefault();
    // 💡 提交到 /passwords/update，同时带上 token 校验身份
    form.put(`/passwords/${token}`);
  }
</script>

<div class="flex items-center justify-center p-4 min-h-[80vh] bg-zinc-50/50">
  <div class="w-full max-w-md space-y-6">
    <Card class="shadow-xl bg-white">
      <CardHeader>
        <CardTitle class="text-2xl text-center font-bold tracking-tight">{t.reset_title}</CardTitle>
        <p class="text-center text-muted-foreground text-sm">{t.reset_subtitle}</p>
      </CardHeader>

      <CardContent class="space-y-4">
        {#if flash.alert}
          <div class="bg-destructive/10 border border-destructive/20 text-destructive p-3 rounded-md text-sm">
            {flash.alert}
          </div>
        {/if}

        <form onsubmit={submit} class="space-y-4">
          <div class="space-y-2">
            <Label for="password">{t.new_password}</Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              bind:value={form.password} required
            />
          </div>

          <div class="space-y-2">
            <Label for="password_confirmation">{t.confirm_new_password}</Label>
            <Input
              id="password_confirmation"
              type="password"
              placeholder="••••••••"
              bind:value={form.password_confirmation} required
            />
          </div>

          <Button type="submit" class="w-full mt-2" disabled={form.processing}> 
            {form.processing ? t.updating : t.submit_reset}
          </Button>
        </form>
      </CardContent>
    </Card>
  </div>
</div>